import React, { useState, useEffect, useContext } from "react";
import PageHeader from "../../Header/PageHeader";
import CustomList from "../../Components/CustomList";
import SplitView from "../../Components/SplitView";
import Pagination from "../../Components/Pagination/Pagination";
import { ApiCallGateway } from "../../Network/apiCallGateway";
import { useQuery } from "@tanstack/react-query";
import { sweetAlert } from "../../Utils/SweetAlert";
import NoteModal from "../../Components/Modal/NoteModal";
import ShareModal from "../../Components/Modal/ShareModal";
import ConfirmModel from "../../Components/Modal/ConfirmModal";
import MovePassword from "../../Components/Modal/MovePassword";
import PwDetailsModal from "../../Components/Modal/PwDetailsModal";
import PasswordForm from "../../Components/Modal/PasswordForm";
import {
  validationSchema,
  getType,
  upperCase,
  lowerCase,
  numbers,
  symbols,
} from "../../Utils/CommonFunction";
import { Button } from "reactstrap";
import { sharePWSchemaObj } from "../../Validation/PasswordValidation";
import { useFormik } from "formik";
import ChangeOwner from "../../Components/Modal/ChangeOwner";
import { DataContext } from "../../context/DataContext";
import ImportCSV from "../../Components/Modal/ImportCSV";
import { decrypt } from "../../Utils/crypto.utils";
import NoData from "../../Components/NoData";
import LogsModal from "../../Components/Modal/LogsModal";
function Created() {
  const {
    getPasswordAccessList,
    getPasswordVault,
    adminViewUser,
    setBrudCrumb,
    setSidebarSelected,
    getLogs,
    logsData,
  } = useContext(DataContext);

  // console.log(adminViewUser);

  const [viewType, setViewType] = useState("list");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [passwordEdit, setPasswordEdit] = useState(false);
  const [noteModal, setNoteModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [moveModal, setMoveModal] = useState(false);
  const [pwDetailsModal, setPwDetailsMoveModal] = useState(false);
  const [note, setNote] = useState("");
  const [pwDetails, setpwDetails] = useState({});
  const [passwordId, setpasswordId] = useState("");
  const [envId, setEnvId] = useState("");
  const [folderId, setFolderId] = useState("");
  const [passwordModal, setPasswordModal] = useState(false);
  const [passwordLength, setPasswordLength] = useState(8);
  const [uppercaseCheck, setUppercaseCheck] = useState(true);
  const [lowercaseCheck, setLowercaseCheck] = useState(true);
  const [numberCheck, setNumberCheck] = useState(true);
  const [symbolCheck, setSymbolCheck] = useState(true);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [generatePassVisible, setGeneratePassVisible] =
    useState(false);
  const [changeOwnerModal, setChangeOwnerModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [password, setPassword] = useState("");
  const [passwordType, setPasswordType] = useState("APIs");
  const [csvModal, setCsvModal] = useState(false);
  const [splitItemData, setSplitItemData] = useState("");
  const [filename, setFilename] = useState("");
  const [secretFile, setSecretFile] = useState("");
  const [logs, setLogs] = useState(false);

  const logsModaltoggle = () => setLogs(!logs);
  const csvModaltoggle = () => setCsvModal(!csvModal);
  const togglePassword = () => setPasswordVisible(!passwordVisible);
  const toggleGeneratePass = () =>
    setGeneratePassVisible(!generatePassVisible);
  const passwordModeltoggle = () => setPasswordModal(!passwordModal);
  const addNotetoggle = () => setNoteModal(!noteModal);
  const sharetoggle = () => setShareModal(!shareModal);
  const confirmtoggle = () => setConfirmModal(!confirmModal);
  const movetoggle = () => setMoveModal(!moveModal);
  const pwDetailstoggle = () =>
    setPwDetailsMoveModal(!pwDetailsModal);
  const changeOwnerModaltoggle = () =>
    setChangeOwnerModal(!changeOwnerModal);
  const {
    isLoading,
    error,
    data: passwordList,
    refetch,
  } = useQuery({
    queryKey: ["passwordList"],
    queryFn: async () => {
      const res = await ApiCallGateway.password.getAllPassword(
        currentPage,
        adminViewUser?._id || null
      );
      if (res?.status === 200) {
        return res?.data;
      } else {
        return [];
      }
    },
  });
  const passwordFormik = useFormik({
    initialValues: validationSchema(
      passwordType,
      pwDetails,
      passwordEdit
    ).initial,
    validationSchema: validationSchema(
      passwordType,
      pwDetails,
      passwordEdit
    ).schma,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      let pwExpiryDate = values?.pwExpiryDate;

      delete values?.pwExpiryDate;

      values = {
        ...values,
        pwExpiryDate: pwExpiryDate ? pwExpiryDate : null,
      };
      let res;
      if (passwordEdit) {
        // console.log(JSON.stringify(values), pwDetails?._id);
        if (
          values?.password === "**********" ||
          values?.apiSecret === "**********"
        ) {
          delete values?.apiSecret;
          delete values?.password;
        }
        if (
          values?.passwordType === "APIs" ||
          values?.passwordType === "Cloud Services"
        ) {
          if (secretFile)
            values = {
              ...values,
              filename: filename,
              secretFile: secretFile,
            };
        }
        res = await ApiCallGateway.password.updatePassword(
          JSON.stringify(values),
          pwDetails?._id
        );
        passwordModeltoggle();
        setPasswordEdit(false);
      } else {
        if (
          values?.passwordType === "APIs" ||
          values?.passwordType === "Cloud Services"
        ) {
          if (secretFile)
            values = {
              ...values,
              filename: filename,
              secretFile: secretFile,
            };
        }
        res = await ApiCallGateway.password.createPassword(
          JSON.stringify(values)
        );
        passwordModeltoggle();
      }

      // console.log(res);
      refetch();
      resetForm();
    },
  });

  const sharePasswordFormik = useFormik({
    initialValues: {
      passwordId: "",
      shareWith: [],
      expiryDate: "",
      permissionType: "View",
      note: "",
    },
    validationSchema: sharePWSchemaObj,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      let data = [];
      // console.log({ ...values, shareWith: selectedUsers });
      for (const element of selectedUsers) {
        let a = {
          passwordId: values.passwordId,
          shareWith: element?._id,
          sharedEmail: element?.email,
          sharedName: element?.name,
          expiryDate: values.expiryDate ? values.expiryDate : null,
          permissionType: values.permissionType,
          note: values.note,
          isNew: !element?._id,
        };
        data.push(a);
      }
      // console.log(data, "kkk");
      const res = await ApiCallGateway.password.sharePassword(data);
      // console.log(res);
      sharetoggle();
      resetForm();
    },
  });

  const changeOwner = async () => {
    const data = {
      passwordIds: selectedItems,
      currentOwner: selectedUsers[0]?._id,
      newOwnerEmail: selectedUsers[0]?.email,
      note: note,
    };
    await ApiCallGateway.ownerShip.changeOwner(data);
  };

  useEffect(() => {
    refetch();
    setSidebarSelected("created");
  }, [currentPage, adminViewUser]);

  useEffect(() => {
    if (generatePassVisible)
      generatePassword(
        uppercaseCheck,
        lowercaseCheck,
        numberCheck,
        symbolCheck
      );
  }, [
    symbolCheck,
    uppercaseCheck,
    numberCheck,
    lowercaseCheck,
    passwordLength,
    generatePassVisible,
  ]);

  const isOpChecked = (param) => {
    let pw;
    if (param === "numbers") {
      pw = numbers();
      return { isChecked: numberCheck, pwGen: pw };
    }
    if (param === "upperCase") {
      pw = upperCase();
      return { isChecked: uppercaseCheck, pwGen: pw };
    }
    if (param === "symbols") {
      pw = symbols();
      return { isChecked: symbolCheck, pwGen: pw };
    }
    if (param === "lowerCase") {
      pw = lowerCase();
      return { isChecked: lowercaseCheck, pwGen: pw };
    }
  };

  async function generatePassword(
    uppercaseCheck,
    lowercaseCheck,
    numberCheck,
    symbolCheck
  ) {
    const symbols = symbolCheck ? 1 : 0;
    const numbers = numberCheck ? 1 : 0;
    const lowercase = lowercaseCheck ? 1 : 0;
    const uppercase = uppercaseCheck ? 1 : 0;
    if (numbers + symbols + uppercase + lowercase === 0) {
      return sweetAlert(
        "Oops!",
        "No box chosen. Please select at least one box!",
        "error"
      );
    }

    let pw = "";

    while (pw.length < passwordLength) {
      let num = Math.floor(Math.random() * getType.length);
      let typeAdder = getType[num];
      let status = isOpChecked(typeAdder);
      if (status?.isChecked) {
        pw += status?.pwGen;
      }
    }
    // setPassword(pw);
    passwordFormik.setFieldValue("password", pw);

    // onGeneratePw(pw);
  }

  const deletepaswword = async (passwordId) => {
    const res = await ApiCallGateway.password.deletePassword(
      passwordId
    );
    if (res?.status === 200) {
      confirmtoggle();
      refetch();
    }
  };

  async function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
      setSecretFile(file);
      setFilename(file?.name);
    });
  }
  // console.log(secretFile, filename);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    try {
      if (file) {
        const base64String = await getBase64(file);
        setFilename(file?.name);

        setSecretFile(base64String);
      } else {
        setSecretFile(null);
        setFilename(null);
      }
    } catch (error) {
      console.error(error);
    }
  };

  function downloadCSVWithHeaders(passwordType) {
    let headers;
    if (passwordType === "APIs") {
      headers = [
        "identifier",
        "platform",
        "passwordType",
        "apikey",
        "apiSecret",
        "note",
      ];
    } else if (passwordType === "Database Access") {
      headers = [
        "identifier",
        "platform",
        "passwordType",
        "port",
        "dbconnectionStrings",
        "username",
        "password",
        "note",
      ];
    } else if (passwordType === "Web Applications") {
      headers = [
        "identifier",
        "platform",
        "passwordType",
        "username",
        "password",
        "note",
      ];
    } else if (passwordType === "Server Access") {
      headers = [
        "identifier",
        "platform",
        "passwordType",
        "port",
        "username",
        "password",
        "note",
      ];
    } else if (passwordType === "Cloud Services") {
      headers = [
        "identifier",
        "platform",
        "passwordType",
        "username",
        "password",
        "note",
      ];
    } else if (passwordType === "Others") {
      headers = ["identifier", "other"];
    }

    const csvContent = headers?.join(",") + "\r\n";
    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "sample_creandential.csv";

    link.click();
  }
  const handleCSVFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const processCSV = async (str, delim = ",") => {
    const headers = str.slice(0, str.indexOf("\n")).split(delim);
    const rows = str.slice(str.indexOf("\n") + 1).split("\n");

    let newArray = [];
    rows.map((row) => {
      const values = row.split(delim);

      if (values.length > 1) {
        const eachObject = headers.reduce((obj, header, i) => {
          if (values[i] === "null" || values[i] === "") {
            obj[header] = null;
          } else {
            obj[header] = values[i];
          }

          return obj;
        }, {});
        newArray.push(eachObject);
        return eachObject;
      }
      return [];
    });
    if (newArray.length > 0) {
      const result = await ApiCallGateway.password.uploadCsv(
        JSON.stringify(newArray)
      );
      // console.log(result);
      if (result === 200) {
        // setLoader(false);
        sweetAlert("Success", "Csv uploaded successfully", "success");
        refetch();
      } else {
        // setLoader(false);
        sweetAlert("Oops!", "Something went wrong", "error");
      }
    }
  };

  const uploadFile = async () => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append("file", selectedFile);

      const reader = new FileReader();

      reader.onload = function (e) {
        const text = e.target.result;
        processCSV(text);
      };

      reader.readAsText(selectedFile);
    }
  };

  const handleCheckboxChange = (itemId) => {
    if (selectedItems.includes(itemId)) {
      setSelectedItems(selectedItems.filter((id) => id !== itemId));
    } else {
      setSelectedItems([...selectedItems, itemId]);
    }
  };

  const handleSelectUsers = (user) => {
    if (!selectedUsers.includes(user)) {
      setSelectedUsers((oldValue) => [...oldValue, user]);
    }
  };
  const handleSelectowner = (user) => {
    if (!selectedUsers.includes(user)) {
      setSelectedUsers([user]);
    }
  };
  const removeSelectUsers = (user) => {
    if (selectedUsers.includes(user)) {
      setSelectedUsers(selectedUsers.filter((u) => u !== user));
    }
  };

  const handleSelectAll = () => {
    if (selectedItems.length === passwordList.data?.length) {
      // console.log("aaaa");
      setSelectedItems([]);
    } else {
      // console.log("b");
      setSelectedItems(passwordList.data?.map((item) => item._id));
    }
  };
  const passwordLogs = (id) => {
    return;
  };
  return (
    <div>
      <PageHeader
        title={"Created"}
        importCSV={true}
        viewType={viewType}
        setViewType={(e) => {
          setViewType(e);
          if (e === "split" && passwordList?.data?.length > 0) {
            setSplitItemData(passwordList?.data[0]);
            getPasswordAccessList(
              passwordList?.data[0]._id,
              passwordList?.data[0].envId,
              passwordList?.data[0].folderId
            );
          } else {
            setSplitItemData({});
          }
        }}
        leftHeader={true}
        splitIcon={true}
        selectAll={() => handleSelectAll()}
        addpasswordToggle={() => {
          setPasswordEdit(false);
          passwordModeltoggle();
          passwordFormik.resetForm();
        }}
        csvModaltoggle={() => csvModaltoggle()}
      />
      <div
        style={{ display: "flex", marginTop: 15, marginBottom: 15 }}
      >
        <CustomList
          selectAll={() => handleSelectAll()}
          allSelected={
            selectedItems.length === passwordList?.data?.length
          }
          selectedItems={selectedItems}
          selectCheckBox={(id) => handleCheckboxChange(id)}
          data={passwordList?.data}
          pwDetailstoggle={(details) => {
            pwDetailstoggle();
            setpwDetails(details);
          }}
          addNotetoggle={(id) => {
            addNotetoggle();
            setpasswordId(id);
          }}
          sharetoggle={(item) => {
            setSelectedUsers([]);
            sharetoggle();
            getPasswordAccessList(
              item?._id,
              item?.envId,
              item?.folderId
            );
            setpasswordId(item?.id);
            setEnvId(item?.envId);
            setFolderId(item?.folderId);
            sharePasswordFormik.setFieldValue("passwordId", item._id);
          }}
          confirmtoggle={(item) => {
            confirmtoggle();
            setpasswordId(item._id);
          }}
          allLogs={(item) => {
            getLogs(item._id, "", 1, "");
            passwordLogs(item._id);
            logsModaltoggle();
          }}
          movetoggle={() => movetoggle()}
          edittoggle={(details) => {
            setpwDetails(details);
            setPasswordType(details?.passwordType);
            setPasswordEdit(!passwordEdit);
            passwordModeltoggle();
          }}
          splitView={viewType === "split" ? true : false}
          splitItemId={splitItemData?._id}
          setSplitData={(item) => {
            setSplitItemData(item);
            getPasswordAccessList(
              item._id,
              item?.envId,
              item?.folderId
            );
          }}
          onCopypassword={(id) => getPasswordVault(id)}
        />
        {viewType === "split" && passwordList?.data?.length > 0 ? (
          <div className="split-view-box">
            <SplitView
              data={splitItemData}
              onCopypassword={(id) => getPasswordVault(id)}
              sharetoggle={(data) => {
                setSelectedUsers([]);
                sharetoggle();
                getPasswordAccessList(
                  data._id,
                  data.envId,
                  data.folderId
                );
                setpasswordId(data?.id);
                setEnvId(data?.envId);
                setFolderId(data?.folderId);
                sharePasswordFormik.setFieldValue(
                  "passwordId",
                  data._id
                );
              }}
              confirmtoggle={(item) => {
                confirmtoggle();
                setpasswordId(item._id);
              }}
              allLogs={(item) => {
                getLogs(item._id, "", 1, "");
                passwordLogs(item._id);
                logsModaltoggle();
              }}
              edittoggle={(details) => {
                setpwDetails(details);
                setPasswordType(details?.passwordType);
                setPasswordEdit(!passwordEdit);
                passwordModeltoggle();
              }}
            />
          </div>
        ) : null}
      </div>
      {selectedItems?.length > 0 ? (
        <Button
          color="primary"
          onClick={() => {
            changeOwnerModaltoggle();
            setSelectedUsers([]);
          }}
        >
          Change owner
        </Button>
      ) : null}
      <ChangeOwner
        changeOwnerModal={changeOwnerModal}
        changeOwnerModaltoggle={changeOwnerModaltoggle}
        selectedUsers={selectedUsers}
        handleSelectUsers={(user) => {
          handleSelectowner(user);
        }}
        removeSelectUsers={(id) => removeSelectUsers(id)}
        setNote={(e) => setNote(e)}
        handleSubmit={() => changeOwner()}
      />
      <PasswordForm
        isEdit={passwordEdit}
        passwordModaltoggle={() => passwordModeltoggle()}
        passwordModal={passwordModal}
        numberCheck={numberCheck}
        numberChecktoggle={() => setNumberCheck(!numberCheck)}
        uppercaseCheck={uppercaseCheck}
        uppercaseChecktoggle={() =>
          setUppercaseCheck(!uppercaseCheck)
        }
        lowercaseCheck={lowercaseCheck}
        lowercaseChecktoggle={() =>
          setLowercaseCheck(!lowercaseCheck)
        }
        symbolCheck={symbolCheck}
        symbolChecktoggle={() => setSymbolCheck(!symbolCheck)}
        passwordLength={passwordLength}
        setPasswordLength={(e) => setPasswordLength(e)}
        onRefresh={() =>
          generatePassword(
            uppercaseCheck,
            lowercaseCheck,
            numberCheck,
            symbolCheck
          )
        }
        passwordVisible={passwordVisible}
        togglePassword={() => togglePassword()}
        generatePassVisible={generatePassVisible}
        toggleGeneratePass={() => toggleGeneratePass()}
        // passwordValue={password}
        passwordType={passwordType}
        setPasswordType={(e) => setPasswordType(e)}
        formik={passwordFormik}
        handleFileChange={(e) => handleFileChange(e)}
      />
      <ImportCSV
        csvModal={csvModal}
        csvModaltoggle={() => csvModaltoggle()}
        csvDownload={(pwType) => downloadCSVWithHeaders(pwType)}
        onFileChange={(file) => handleCSVFileChange(file)}
        uploadCsv={uploadFile}
      />
      {passwordList?.data?.length < 1 ? <NoData /> : null}

      <Pagination
        totalPost={passwordList?.total}
        postsPerPage={passwordList?.limit}
        setCurrentPage={(e) => setCurrentPage(e)}
        currentPage={currentPage}
      />
      <PwDetailsModal
        pwDetailsModal={pwDetailsModal}
        pwDetailsModaltoggle={pwDetailstoggle}
        details={pwDetails}
      />
      <NoteModal
        noteModal={noteModal}
        noteModaltoggle={addNotetoggle}
      />
      <ShareModal
        isPassword={true}
        shareModal={shareModal}
        shareModaltoggle={sharetoggle}
        formik={sharePasswordFormik}
        handleSelectUsers={(user) => {
          handleSelectUsers(user);
        }}
        removeSelectUsers={(id) => removeSelectUsers(id)}
        selectedUsers={selectedUsers}
        refetchAccessList={() =>
          getPasswordAccessList(
            sharePasswordFormik?.values?.passwordId,
            envId,
            folderId
          )
        }
      />
      <ConfirmModel
        confirmModal={confirmModal}
        confirmModaltoggle={confirmtoggle}
        passwordId={passwordId}
        onProceed={(id) => deletepaswword(id)}
      />
      <LogsModal
        logsModal={logs}
        logsModaltoggle={logsModaltoggle}
        logs={logsData}
        logsPage={(dataId, n) => {
          getLogs(dataId, "", n, "");
        }}
      />
      <MovePassword
        moveModal={moveModal}
        moveModaltoggle={movetoggle}
      />
    </div>
  );
}

export default Created;
